import React, { useEffect, useState } from 'react';
import './styles.css';
import LoginForm from './LoginForm';
import AuthLayout from '../../layout/AuthLayout';
import PasswordRecovery from './PasswordRecovery';


const Login: React.FC = () => {
  const [showPasswordRecory, setShowPasswordRecovery] = useState<boolean>(false);
  const [showRegister, setShowRegister] = useState<boolean>(false);

  const handlerShowRecuperarSenha = () => setShowPasswordRecovery((show) => !show);

  useEffect(() => {
    scrollTop();
  }, [showRegister]);

  const scrollTop = (): void => {
    window.scrollTo(0, 0);
  };

  return (
    <AuthLayout>
      <div className='width-100 login-container-end'>
        {!showPasswordRecory ?
          <LoginForm
            handlerShowRecuperarSenha={handlerShowRecuperarSenha}
          />
          :
          <PasswordRecovery
            handlerShowRecuperarSenha={handlerShowRecuperarSenha}
          />
        }
      </div>
    </AuthLayout>
  );
};

export default Login;
